import { ROUTES } from "@/constants";
import { AuthContext } from "@/services/AuthContext";
import { useWeb3Auth, web3authInstance } from "@/services/Web3AuthService";
import useStore from "@/store/useStore";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { IoLogOutOutline } from "react-icons/io5";
import { NavLink, useNavigate } from "react-router-dom";

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { reset } = useStore();
  // eslint-disable-next-line
  const { web3auth, initializeWeb3Auth } = useWeb3Auth();

  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    try {
      if (web3authInstance.connected) {
        // Check if the user is connected before logging out
        await web3authInstance.logout();
      }
    } catch (error) {
      toast.error("Web3Auth logout error");
    }
    
    await logout(); // Log out from your application
    localStorage.removeItem("authToken");
    localStorage.removeItem("web3AuthToken");
    reset(); // Reset store data
    navigate(ROUTES.APP_ROOT); // Redirect to the home page
    window.location.reload(); // Ensure a fresh state
  };

  return (
    <NavLink to={"/"} onClick={handleLogout} className="text-[#FF1E1E] flex items-center text-lg py-4">
      <div className="flex justify-items-center">
        <IoLogOutOutline className="h-5 w-5" />
        <span className={`pl-4 flex my-auto text-xs `}>Logout</span>
      </div>
      <p className="w-[0.25rem] h-5 bg-primary-500 hidden"></p>
    </NavLink>
  );
};

export default Logout;
